import React, { useState, useEffect } from "react";
import {
  Form,
  Input,
  Row,
  Col,
  Select,
  Button,
  notification,
  Radio,
  Card,
  Checkbox,
  Space,
  Spin,
  DatePicker,
  Switch,
} from "antd";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import _ from "lodash";
import moment from "moment";
import {
  PlusCircleOutlined,
  DeleteOutlined,
  CheckOutlined,
  CloseOutlined,
} from "@ant-design/icons";

/* custom component */
import { PageContainer, LayoutContainer } from "../../../component/Xcomponent";

/* actions */
import {
  saveEmergencyDtrf,
  saveEmergencyDtrfReset,
} from "../../../action/saveEmergencyDtrfAction";
import {
  getListTestMaster,
  getListTestMasterReset,
} from "../../../action/getListTestMasterActions";
import {
  getContainerList,
  getContainerListReset,
} from "../../../action/getContainerListAction";
import {
  getPatientDropdownList,
  getPatientDropdownListReset,
} from "../../../action/getPatientDropdownListAction";

//Others
import { ContainerTable } from "./EmergencyDtrfSaveStyle";

/* otehrs */
export const EmergencyDtrfSave = (props) => {
  /* variables */
  const {
    getListTestMaster,
    getListTestMasterReset,
    getListTestMasterState,
    getContainerList,
    getContainerListReset,
    getContainerListState,
    getDoctorDetailState,
    getPatientDropdownList,
    getPatientDropdownListState,
    getPatientDropdownListReset,
    saveEmergencyDtrf,
    saveEmergencyDtrfState,
    saveEmergencyDtrfReset,
  } = props;

  const initialFormData = {
    test_id: [],
    institute_id: "",
    patient_id: [],
    new_patients: [],
    sample_container: [],
    sampleInfo: [],
    location: "",
    patient_name: "",
    patient_mobile_number: "",
    patient_gender: "",
    patient_dob_in_date: "",
    patient_dob_in_year: "",
    patient_dob_in_month: "",
    patient_dob_in_day: "",
    age_in: "",
  };
  const [formData, setFormData] = useState(initialFormData);

  const [emergencyDtrfDataMap, setEmergencyDtrfDataMap] = useState({
    patient_list: [],
  });
  const [multiplePatient, setMultiplePatient] = useState();
  const [addNewPatient, setAddNewPatient] = useState(false);
  const [homeCollectionPossible, setHomeCollectionPossible] = useState();

  const [containerRefresh, setContainerRefresh] = useState(0);
  const [gender, setGender] = useState([]);

  const [redirect, setRedirect] = useState([false, ""]);
  const [form] = Form.useForm();
  const [formSampleInfo] = Form.useForm();

  /* callbacks */
  useEffect(() => {
    getListTestMaster({ dropDownList: "/get-dropdown-list" });
    getPatientDropdownList({ dropdown: true });
    return () => {
      getListTestMasterReset();
      getContainerListReset();
      saveEmergencyDtrfReset();
      getPatientDropdownListReset();
    };
  }, []);

  useEffect(() => {
    if (getDoctorDetailState.apiState === "success") {
      if (getDoctorDetailState.data.is_dtrf_activated !== "Yes") {
        setRedirect([true, "/"]);
      }
    }
  }, [getDoctorDetailState]);

  useEffect(() => {
    if (saveEmergencyDtrfState.apiState === "success") {
      notification["success"]({
        message: saveEmergencyDtrfState.message,
        placement: "topRight",
      });
      form.resetFields();
      formSampleInfo.resetFields();
      setEmergencyDtrfDataMap({
        ...emergencyDtrfDataMap,
        ["patient_list"]: [],
      });
      setFormData(initialFormData);
      setHomeCollectionPossible();
      setMultiplePatient();
      saveEmergencyDtrfReset();
    } else if (saveEmergencyDtrfState.apiState === "error") {
      notification["error"]({
        message: saveEmergencyDtrfState.message,
        placement: "topRight",
      });
    }
  }, [saveEmergencyDtrfState]);

  /* functions */

  const handleOnChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };
  const handleDateChange = (name, date, dateString) => {
    setFormData({ ...formData, [name]: dateString });
  };
  const handleOnChangeSelect = (name, v) => {
    setFormData({ ...formData, [name]: v });
  };
  const handleChangeInstitute = (name, value) => {
    setFormData({
      ...formData,
      [name]: value,
      ["test_id"]: [],
      ["new_patients"]: [],
      ["location"]: "",
    });
    form.setFieldsValue({
      test_id: [],
      new_patients: [],
      location: "",
    });
    setAddNewPatient(false);
    setEmergencyDtrfDataMap({ ...emergencyDtrfDataMap, ["patient_list"]: [] });
    setHomeCollectionPossible("");
  };

  const handleContainerChange = (value, sample_id, t_index, p_index) => {
    let sample_container = _.find(
      emergencyDtrfDataMap.patient_list[p_index].test_list[t_index]
        .sample_container,
      { sample_id: sample_id }
    );

    if (sample_container) {
      sample_container.container_id = value;
    }
    setContainerRefresh(containerRefresh + 1);
  };
  const handleContainerID = (value, sample_id, t_index, p_index) => {
    let sample_container = _.find(
      emergencyDtrfDataMap.patient_list[p_index].test_list[t_index]
        .sample_container,
      { sample_id: sample_id }
    );
    sample_container.containerId = value;
    setContainerRefresh(containerRefresh + 1);
  };

  const addRowContainer = (
    container_id,
    containerId,
    sample_id,
    t_index,
    p_index
  ) => {
    let sample_container = _.find(
      emergencyDtrfDataMap.patient_list[p_index].test_list[t_index]
        .sample_container,
      { sample_id: sample_id }
    );
    if (
      sample_container &&
      sample_container.container_id &&
      sample_container.containerId
    ) {
      let container_data = _.find(getContainerListState.list, function (o) {
        return (
          (o.sample = sample_id),
          (o.container._id = sample_container.container_id)
        );
      });

      let sample_container_list = _.find(
        emergencyDtrfDataMap.patient_list[p_index].test_list[t_index]
          .sample_container_list,
        { sample_id: sample_id }
      );
      if (sample_container_list) {
        sample_container_list.container.push({
          container_name: container_data.container.display_container_name,
          container_id: sample_container.container_id,
          containerId: sample_container.containerId,
        });
      } else {
        emergencyDtrfDataMap.patient_list[p_index].test_list[
          t_index
        ].sample_container_list.push({
          sample_id: sample_id,
          container: [
            {
              container_name: container_data.container.display_container_name,
              container_id: sample_container.container_id,
              containerId: sample_container.containerId,
            },
          ],
        });
      }
      // _.remove(emergencyDtrfDataMap.patient_list[p_index].test_list[t_index].sample_container, { sample_id: sample_id })
      // emergencyDtrfDataMap.patient_list[p_index].test_list[t_index].sample_container.push({
      // 	sample_id: sample_id
      // })
      formSampleInfo.setFieldsValue({
        [container_id]: null,
        [containerId]: "",
      });
      setContainerRefresh(containerRefresh + 1);
    }
  };

  const deleteRowContainer = (p_index, t_index, sample_id, container_index) => {
    let container = [];
    _.find(
      emergencyDtrfDataMap.patient_list[p_index].test_list[t_index]
        .sample_container_list,
      { sample_id: sample_id }
    ).container.map((item, i) => {
      if (i !== container_index) {
        container.push(item);
      }
    });
    let sample_container_list = _.find(
      emergencyDtrfDataMap.patient_list[p_index].test_list[t_index]
        .sample_container_list,
      { sample_id: sample_id }
    );
    sample_container_list.container = container;
    setContainerRefresh(containerRefresh + 1);
  };

  const handleSelectTest = (name, value) => {
    let test_record = {};
    let test_id = [];
    let genderList = [];
    value.map((item) => {
      test_record = _.find(getListTestMasterState.list, { _id: item });
      let test_list = _.find(formData.test_id, { test_id: item });
      if (test_list) {
        test_id.push(test_list.test_id);
        if (test_record.sex.length > 0) {
          test_record.sex.map((data) => {
            genderList.push({ gender: _.trim(data) });
          });
        }
      } else {
        let multiple_patient = false;
        if (test_record?.multiple_patient) {
          multiple_patient = test_record.multiple_patient;
        }
        if (
          formData.test_id.length > 0 &&
          multiplePatient !== multiple_patient
        ) {
          notification["error"]({
            message:
              "Please select same Test name for multiple patient status.",
            placement: "bottomRight",
          });
        } else {
          test_id.push(item);
          if (test_record.sex.length > 0) {
            test_record.sex.map((data) => {
              genderList.push({ gender: _.trim(data) });
            });
          }
          setMultiplePatient(multiple_patient);
          if (formData.test_id.length === 0) {
            let home_collection_possible = false;
            if (test_record?.home_collection_possible) {
              setHomeCollectionPossible(test_record.home_collection_possible);
            } else {
              setHomeCollectionPossible(home_collection_possible);
            }
          }
        }
      }
    });
    formSampleInfo.resetFields();

    setFormData({
      ...formData,
      [name]: test_id,
      ["patient_id"]: [],
      ["new_patients"]: [],
      ["location"]: "",
    });

    form.setFieldsValue({
      [name]: test_id,
      patient_id: [],
      new_patients: [],
      sample_id: "",
      location: "",
    });
    if (test_id.length === 0) {
      setHomeCollectionPossible("");
    }
    setGender(_.uniqBy(genderList, "gender"));
    setAddNewPatient(false);
    setEmergencyDtrfDataMap({ ...emergencyDtrfDataMap, ["patient_list"]: [] });

    setContainerRefresh(containerRefresh + 1);
  };

  const handleChangePatient = (name, value) => {
    let test_record = {};
    let test_list_array = [];
    let patient_list_array = [];
    let patient_id = [];
    if (typeof value === "string") {
      patient_id.push(value);
    } else {
      patient_id = value ? value : [];
    }
    patient_id.map((p_item) => {
      let patient_list = _.find(emergencyDtrfDataMap.patient_list, {
        patient_id: p_item,
      });
      if (patient_list) {
        patient_list_array.push(patient_list);
      } else {
        formData.test_id.map((item) => {
          test_record = _.find(getListTestMasterState.list, { _id: item });
          let home_collection_possible = false;
          if (test_record?.home_collection_possible) {
            home_collection_possible = test_record.home_collection_possible;
          }

          let multiple_sample = false;
          if (test_record?.multiple_sample) {
            multiple_sample = test_record.multiple_sample;
          }

          let sample_type = [];
          if (test_record?.sample_type) {
            sample_type = test_record.sample_type;
          }
          test_list_array.push({
            test_id: item,
            test_name: test_record?.display_test_name,
            test_description: test_record?.description,
            home_collection_possible: home_collection_possible,
            multiple_sample: multiple_sample,
            sample_type: sample_type,
            test_group: test_record?.test_group,
            sample_container: [],
            sample_container_list: [],
          });
        });
        let patient_record = _.find(getPatientDropdownListState.list, {
          _id: p_item,
        });
        patient_list_array.push({
          patient_name: patient_record.name.firstName,
          patient_id: p_item,
          test_list: test_list_array,
        });
      }
    });

    let new_patient_list_array = [];
    formData.new_patients.map((p_item) => {
      let new_patient_list = _.find(emergencyDtrfDataMap.patient_list, {
        patient_name: p_item.patient_name,
        patient_mobile_number: p_item.patient_mobile_number,
        patient_gender: p_item.patient_gender,
        patient_dob_in_date: p_item.patient_dob_in_date,
        patient_dob_in_year: p_item.patient_dob_in_year,
        patient_dob_in_month: p_item.patient_dob_in_month,
        patient_dob_in_day: p_item.patient_dob_in_day,
        age_in: p_item.age_in,
      });
      if (new_patient_list) {
        new_patient_list_array.push(new_patient_list);
      }
    });

    let list = _.concat(patient_list_array, new_patient_list_array);

    setFormData({
      ...formData,
      [name]: patient_id,
    });
    form.setFieldsValue({
      [name]: patient_id,
    });
    if (!multiplePatient) {
      formSampleInfo.resetFields();
    }
    setEmergencyDtrfDataMap({
      ...emergencyDtrfDataMap,
      ["patient_list"]: list,
    });
    setContainerRefresh(containerRefresh + 1);
  };

  const handleCheckboxChanged = (checked, value, p_index, t_index) => {
    if (checked) {
      let sample_container = formData.sample_container;
      sample_container.push({
        sample_id: value,
        container_id: [],
      });
      setFormData({
        ...formData,
        ["sample_container"]: sample_container,
      });

      let sample_container_data =
        emergencyDtrfDataMap.patient_list[p_index].test_list[t_index]
          .sample_container;
      sample_container_data.push({
        sample_id: value,
      });
    } else {
      let arr = formData.sample_container;
      arr = arr.length > 0 ? arr.filter((el) => el.sample_id !== value) : [];
      setFormData({ ...formData, ["sample_container"]: arr });
      _.remove(
        emergencyDtrfDataMap.patient_list[p_index].test_list[t_index]
          .sample_container,
        { sample_id: value }
      );
      _.remove(
        emergencyDtrfDataMap.patient_list[p_index].test_list[t_index]
          .sample_container_list,
        { sample_id: value }
      );
    }
    setContainerRefresh(containerRefresh + 1);
  };

  const handleOnChangeRadio = (value, t_index, p_index) => {
    let sample_container = {
      sample_id: value,
      container_id: [],
    };
    setFormData({ ...formData, ["sample_container"]: [sample_container] });
    emergencyDtrfDataMap.patient_list[p_index].test_list[
      t_index
    ].sample_container = [{ sample_id: value }];
    // emergencyDtrfDataMap.patient_list[p_index].test_list[t_index].sample_container.push({
    // 	sample_id: value
    // })
    emergencyDtrfDataMap.patient_list[p_index].test_list[
      t_index
    ].sample_container_list = [];
    setContainerRefresh(containerRefresh + 1);
  };

  const handleOnChangeHomeCollection = (value) => {
    setFormData({ ...formData, ["location"]: value });
  };

  // const handleOnChangPatientType = (value) => {
  // 	setFormData({
  // 		...formData,
  // 		['patient_type']: value,
  // 		['patient_id']: [],
  // 		['new_patients']: [],
  // 	})
  // 	form.setFieldsValue({
  // 		['patient_id']: [],
  // 		['new_patients']: [],
  // 	})
  // 	formSampleInfo.resetFields()
  // 	setEmergencyDtrfDataMap({ ...emergencyDtrfDataMap, ['patient_list']: [] })
  // }

  const addRowPatient = () => {
    if (
      (formData.patient_dob_in_date ||
        (formData.patient_dob_in_year &&
          formData.patient_dob_in_month &&
          formData.patient_dob_in_day)) &&
      formData.patient_gender &&
      formData.patient_mobile_number &&
      formData.patient_name
    ) {
      let test_record = {};
      let test_list_array = [];
      let patient_list_array = [];
      let old_patient_list_array = [];
      formData.patient_id.map((p_item) => {
        let old_patient_list = _.find(emergencyDtrfDataMap.patient_list, {
          patient_id: p_item,
        });
        if (old_patient_list) {
          old_patient_list_array.push(old_patient_list);
        }
      });

      let new_patient_object = formData.new_patients;
      new_patient_object.push({
        patient_dob_in_date: formData.patient_dob_in_date,
        patient_dob_in_year: formData.patient_dob_in_year,
        patient_dob_in_month: formData.patient_dob_in_month,
        patient_dob_in_day: formData.patient_dob_in_day,
        patient_gender: formData.patient_gender,
        patient_mobile_number: formData.patient_mobile_number,
        patient_name: formData.patient_name,
        age_in: formData.age_in,
      });

      new_patient_object.map((p_item) => {
        let patient_list = _.find(emergencyDtrfDataMap.patient_list, {
          patient_name: p_item.patient_name,
          patient_mobile_number: p_item.patient_mobile_number,
          patient_gender: p_item.patient_gender,
          patient_dob_in_date: p_item.patient_dob_in_date,
          patient_dob_in_year: p_item.patient_dob_in_year,
          patient_dob_in_month: p_item.patient_dob_in_month,
          patient_dob_in_day: p_item.patient_dob_in_day,
          age_in: p_item.age_in,
        });
        if (patient_list) {
          patient_list_array.push(patient_list);
        } else {
          formData.test_id.map((item) => {
            test_record = _.find(getListTestMasterState.list, { _id: item });
            let home_collection_possible = false;
            if (test_record?.home_collection_possible) {
              home_collection_possible = test_record.home_collection_possible;
            }

            let multiple_sample = false;
            if (test_record?.multiple_sample) {
              multiple_sample = test_record.multiple_sample;
            }

            let sample_type = [];
            if (test_record?.sample_type) {
              sample_type = test_record.sample_type;
            }
            test_list_array.push({
              test_id: item,
              test_name: test_record?.display_test_name,
              test_description: test_record?.description,
              home_collection_possible: home_collection_possible,
              multiple_sample: multiple_sample,
              sample_type: sample_type,
              test_group: test_record?.test_group,
              sample_container: [],
              sample_container_list: [],
            });
          });
          patient_list_array.push({
            patient_id: "",
            patient_name: p_item.patient_name,
            patient_mobile_number: p_item.patient_mobile_number,
            patient_gender: p_item.patient_gender,
            patient_dob_in_date: p_item.patient_dob_in_date,
            patient_dob_in_year: p_item.patient_dob_in_year,
            patient_dob_in_month: p_item.patient_dob_in_month,
            patient_dob_in_day: p_item.patient_dob_in_day,
            age_in: p_item.age_in,
            test_list: test_list_array,
          });
        }
      });
      if (!multiplePatient) {
        formSampleInfo.resetFields();
      }
      setFormData({
        ...formData,
        ["new_patients"]: new_patient_object,
        ["patient_name"]: "",
        ["patient_mobile_number"]: "",
        ["patient_gender"]: "",
        ["patient_dob_in_date"]: "",
        ["patient_dob_in_year"]: "",
        ["patient_dob_in_month"]: "",
        ["patient_dob_in_day"]: "",
        ["age_in"]: "",
      });
      form.setFieldsValue({
        patient_name: "",
        patient_mobile_number: "",
        patient_gender: null,
        patient_dob_in_date: null,
        patient_dob_in_year: "",
        patient_dob_in_month: "",
        patient_dob_in_day: "",
        age_in: "",
      });

      let list = _.concat(old_patient_list_array, patient_list_array);
      setEmergencyDtrfDataMap({
        ...emergencyDtrfDataMap,
        ["patient_list"]: list,
      });
      setContainerRefresh(containerRefresh + 1);
    }
  };

  const deleteRowPatient = (p_index) => {
    let a = _.filter(emergencyDtrfDataMap.patient_list, function (o, index) {
      return index !== p_index;
    });
    setEmergencyDtrfDataMap({ patient_list: a });
    let fd = _.filter(formData.new_patient_object, function (o, index) {
      return index !== p_index;
    });
    setFormData({
      ...formData,
      ["new_patients"]: fd,
    });
  };

  const handleSubmit = () => {
    let sampleInfo = [];
    let sample_id = [];
    let containers = [];
    let throw_error = false;
    emergencyDtrfDataMap.patient_list.map((patient_list) => {
      // Patient Array
      let testArray = [];
      let sampleTestArray = [];
      patient_list.test_list.map((test_list) => {
        // Test Array
        let sampleTypeArray = [];
        let sampleArray = [];
        if (test_list.sample_container_list.length === 0) {
          notification["error"]({
            message: "Please add at least one contaienr in all sample.",
            placement: "bottomRight",
          });
          throw_error = true;
        }
        test_list.sample_container_list.map((sample_list) => {
          // Sample Array
          let containerArray = [];
          sample_id.push(sample_list.sample_id);
          sampleTypeArray.push(sample_list.sample_id);
          if (sample_list.container.length === 0) {
            notification["error"]({
              message: "Please add at least one contaienr in all sample.",
              placement: "bottomRight",
            });
            throw_error = true;
          }
          sample_list.container.map((container) => {
            // Container Array
            containerArray.push({
              containerId: container.containerId,
              containerType: container.container_name,
            });
            containers.push({
              containerId: container.containerId,
              containerType: container.container_name,
            });
          });
          sampleArray.push(containerArray);
        });
        testArray.push(sampleArray);
        sampleTestArray.push(sampleTypeArray);
      });
      sampleInfo.push({
        sample_info: {
          sampleInfo: [testArray],
          sampleType: [sampleTestArray],
        },
      });
    });
    let data = {
      sampleInfo: sampleInfo,
    };

    if (!throw_error) {
      saveEmergencyDtrf({
        sample_info: data,
        sample_id: sample_id,
        containers: containers,
        patient_id: formData.patient_id,
        new_patients: formData.new_patients,
        test_id: formData.test_id,
        institute_id: formData.institute_id,
        location: formData.location,
      });
    }
  };

  return (
    <>
      {redirect[0] && <Redirect to={redirect[1]} />}
      <PageContainer>
        <Card title={"Add Emergency DTRF"} bordered={false}>
          <LayoutContainer>
            <Form form={form} layout="vertical" onFinish={handleSubmit}>
              <Row gutter={20}>
                <Col xs={24} sm={24} md={12} lg={8} xl={8}>
                  <Form.Item
                    label="Institute"
                    name="institute_id"
                    rules={[{ required: true, message: "Required" }]}
                  >
                    <Select
                      showSearch
                      name="institute_id"
                      placeholder="Select Institute"
                      allowClear
                      filterOption={(input, option) =>
                        option.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      }
                      onChange={(v) => handleChangeInstitute("institute_id", v)}
                    >
                      {getDoctorDetailState.apiState === "success" &&
                        getDoctorDetailState.data.hospital.map(
                          (item, index) => {
                            return (
                              <Select.Option
                                value={`${item._id}`}
                                key={`${index}`}
                              >
                                {item.name}
                              </Select.Option>
                            );
                          }
                        )}
                    </Select>
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={12} lg={8} xl={8}>
                  <Form.Item
                    label="Test Name"
                    name="test_id"
                    rules={[{ required: true, message: "Required" }]}
                  >
                    <Select
                      showSearch
                      name="test_id"
                      placeholder="Select Test Name"
                      allowClear
                      filterOption={(input, option) =>
                        option.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      }
                      onChange={(v) => handleSelectTest("test_id", v)}
                      mode="multiple"
                      disabled={!formData.institute_id}
                    >
                      {getListTestMasterState.list.map((item, index) => {
                        return (
                          <Select.Option value={`${item._id}`} key={`${index}`}>
                            {item.display_test_name}
                          </Select.Option>
                        );
                      })}
                    </Select>
                  </Form.Item>
                </Col>
                {(homeCollectionPossible === false ||
                  homeCollectionPossible === true) && (
                  <Col xs={24} sm={24} md={12} lg={8} xl={8}>
                    <Form.Item
                      label="Location"
                      name={`location`}
                      rules={[{ required: true, message: "Required" }]}
                    >
                      <Radio.Group
                        name={`location`}
                        onChange={(e) =>
                          handleOnChangeHomeCollection(e.target.value)
                        }
                      >
                        <Space direction="horizontal" wrap>
                          {homeCollectionPossible === false ? (
                            <Radio value="Institute">Institute</Radio>
                          ) : (
                            <Radio value="Non Institute">Non Institute</Radio>
                          )}
                        </Space>
                      </Radio.Group>
                    </Form.Item>
                  </Col>
                )}
                {/* {formData.location &&
									<Col xs={24} sm={24} md={12} lg={8} xl={8}>
										<Form.Item
											label="Select Patient Type"
											name={`patient_type`}
											rules={[{ required: true, message: "Required" }]}
										>
											<Radio.Group name={`patient_type`} onChange={(e) => handleOnChangPatientType(e.target.value)} >
												<Space direction="horizontal" wrap>
													<Radio value="Old Patient">Old Patient</Radio>
													<Radio value="Create New Patient">Create New Patient</Radio>
												</Space>
											</Radio.Group>

										</Form.Item>
									</Col>
								} */}
                {formData.location && (
                  <>
                    {(multiplePatient ||
                      (multiplePatient === false &&
                        formData.new_patients.length === 0)) && (
                      <Col xs={24} sm={24} md={12} lg={8} xl={8}>
                        <Form.Item
                          label="Select Patient"
                          name="patient_id"
                          rules={[
                            { required: true, message: "Name is required!" },
                          ]}
                        >
                          <Select
                            name="patient_id"
                            placeholder="Select patient name"
                            allowClear
                            onChange={(v) =>
                              handleChangePatient("patient_id", v)
                            }
                            showSearch
                            // filterOption={(input, option) =>
                            // 	option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            // }
                            mode={multiplePatient ? "multiple" : ""}
                            disabled={formData.test_id.length === 0}
                          >
                            {getPatientDropdownListState.list.map((obj) => (
                              <Select.Option value={obj._id} key={obj._id}>
                                {obj.name.firstName} {obj.name.lastName} |{" "}
                                {obj.phone}
                              </Select.Option>
                            ))}
                          </Select>
                        </Form.Item>
                      </Col>
                    )}
                    {(multiplePatient ||
                      (multiplePatient === false &&
                        formData.patient_id.length === 0)) && (
                      <Col xs={24} sm={24} md={12} lg={8} xl={8}>
                        <Form.Item label="Add New Patient">
                          <Switch
                            checkedChildren={<CheckOutlined />}
                            unCheckedChildren={<CloseOutlined />}
                            checked={addNewPatient}
                            onChange={(checked) => setAddNewPatient(checked)}
                            disabled={formData.new_patients.length > 0}
                          />
                        </Form.Item>
                      </Col>
                    )}
                  </>
                )}
              </Row>
              {(multiplePatient ||
                (multiplePatient === false &&
                  formData.patient_id.length === 0)) && (
                <Row
                  gutter={20}
                  style={{ display: "flex", alignItems: "center" }}
                >
                  {addNewPatient && (
                    <>
                      <Col xs={24} sm={24} md={12} lg={8} xl={8}>
                        <Form.Item
                          label="Patient Name"
                          name="patient_name"
                          rules={[
                            {
                              required:
                                emergencyDtrfDataMap.patient_list.length > 0
                                  ? false
                                  : true,
                              message: "Required",
                            },
                          ]}
                        >
                          <Input
                            name="patient_name"
                            placeholder="Enter Patient Name"
                            onChange={handleOnChange}
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={12} lg={8} xl={8}>
                        <Form.Item
                          rules={[
                            {
                              required:
                                emergencyDtrfDataMap.patient_list.length > 0
                                  ? false
                                  : true,
                              message: "Required",
                            },
                            {
                              pattern: new RegExp("^[6-9]\\d{9}$"),
                              message: "Mobile number is not valid",
                            },
                          ]}
                          label="Patient Mobile Number"
                          name="patient_mobile_number"
                        >
                          <Input
                            name="patient_mobile_number"
                            placeholder="Enter Patient Mobile Number"
                            onChange={handleOnChange}
                            style={{ width: "100%" }}
                          ></Input>
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={12} lg={8} xl={8}>
                        <Form.Item
                          label="Gender"
                          name="patient_gender"
                          rules={[
                            {
                              required:
                                emergencyDtrfDataMap.patient_list.length > 0
                                  ? false
                                  : true,
                              message: "Required",
                            },
                          ]}
                        >
                          <Select
                            onChange={(v) =>
                              handleOnChangeSelect("patient_gender", v)
                            }
                            name="patient_gender"
                            placeholder="Select Gender"
                          >
                            {gender.map((item) => (
                              <>
                                <Select.Option value={item.gender}>
                                  {item.gender}
                                </Select.Option>
                              </>
                            ))}
                          </Select>
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={12} lg={8} xl={8}>
                        <Form.Item
                          label="Age In"
                          name={`age_in`}
                          rules={[
                            {
                              required:
                                emergencyDtrfDataMap.patient_list.length > 0
                                  ? false
                                  : true,
                              message: "Required",
                            },
                          ]}
                        >
                          <Radio.Group
                            name={`age_in`}
                            onChange={(e) =>
                              handleOnChangeSelect("age_in", e.target.value)
                            }
                          >
                            <Space direction="horizontal" wrap>
                              <Radio value="Date of Birth">Date of Birth</Radio>
                              <Radio value="Years-Months-Days">
                                Years-Months-Days
                              </Radio>
                            </Space>
                          </Radio.Group>
                        </Form.Item>
                      </Col>
                      {formData.age_in === "Date of Birth" && (
                        <Col xs={24} sm={24} md={12} lg={8} xl={8}>
                          <Form.Item
                            label=" Date of Birth"
                            name="patient_dob_in_date"
                            rules={[
                              {
                                required:
                                  emergencyDtrfDataMap.patient_list.length > 0
                                    ? false
                                    : true,
                                message: "Required",
                              },
                            ]}
                          >
                            <DatePicker
                              name="patient_dob_in_date"
                              placeholder="Birth Date"
                              onChange={(date, dateString) =>
                                handleDateChange(
                                  "patient_dob_in_date",
                                  date,
                                  dateString
                                )
                              }
                              style={{
                                width: "100%",
                              }}
                              format={"DD-MM-YYYY"}
                            />
                          </Form.Item>
                        </Col>
                      )}
                      {formData.age_in === "Years-Months-Days" && (
                        <>
                          <Col xs={24} sm={24} md={6} lg={3} xl={3}>
                            <Form.Item
                              label="Day"
                              name="patient_dob_in_day"
                              rules={[
                                {
                                  required:
                                    emergencyDtrfDataMap.patient_list.length > 0
                                      ? false
                                      : true,
                                  message: "Required",
                                },
                              ]}
                            >
                              <DatePicker
                                name="patient_dob_in_day"
                                placeholder="Birth Date"
                                onChange={(date, dateString) =>
                                  handleDateChange(
                                    "patient_dob_in_day",
                                    date,
                                    dateString
                                  )
                                }
                                style={{
                                  width: "100%",
                                }}
                                picker="day"
                                format={"DD"}
                              />
                            </Form.Item>
                          </Col>
                          <Col xs={24} sm={24} md={6} lg={3} xl={3}>
                            <Form.Item
                              label="Month"
                              name="patient_dob_in_month"
                              rules={[
                                {
                                  required:
                                    emergencyDtrfDataMap.patient_list.length > 0
                                      ? false
                                      : true,
                                  message: "Required",
                                },
                              ]}
                            >
                              <DatePicker
                                name="patient_dob_in_month"
                                placeholder="Birth Date"
                                onChange={(date, dateString) =>
                                  handleDateChange(
                                    "patient_dob_in_month",
                                    date,
                                    dateString
                                  )
                                }
                                style={{
                                  width: "100%",
                                }}
                                picker="month"
                                format={"MM"}
                              />
                            </Form.Item>
                          </Col>
                          <Col xs={24} sm={24} md={6} lg={3} xl={3}>
                            <Form.Item
                              label="Year"
                              name="patient_dob_in_year"
                              rules={[
                                {
                                  required:
                                    emergencyDtrfDataMap.patient_list.length > 0
                                      ? false
                                      : true,
                                  message: "Required",
                                },
                              ]}
                            >
                              <DatePicker
                                name="patient_dob_in_year"
                                placeholder="Birth Date"
                                onChange={(date, dateString) =>
                                  handleDateChange(
                                    "patient_dob_in_year",
                                    date,
                                    dateString
                                  )
                                }
                                style={{
                                  width: "100%",
                                }}
                                picker="year"
                                format={"YYYY"}
                              />
                            </Form.Item>
                          </Col>
                        </>
                      )}
                      {(multiplePatient ||
                        (multiplePatient === false &&
                          emergencyDtrfDataMap.patient_list.length === 0)) && (
                        <Col xs={24} sm={24} md={12} lg={6} xl={6}>
                          <Button type="ghost" onClick={addRowPatient}>
                            <PlusCircleOutlined />
                            Add
                          </Button>
                        </Col>
                      )}
                      <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                        <ContainerTable>
                          <thead>
                            <tr>
                              <th>Patient Name</th>
                              <th>Patient Mobile Number</th>
                              <th>Gender</th>
                              <th>Date of Birth</th>
                              <th>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {emergencyDtrfDataMap.patient_list.map(
                              (patient_list_item, p_index) =>
                                patient_list_item.patient_gender && (
                                  <tr>
                                    <td>{patient_list_item.patient_name}</td>
                                    <td>
                                      {patient_list_item.patient_mobile_number}
                                    </td>
                                    <td>{patient_list_item.patient_gender}</td>
                                    <td>
                                      {patient_list_item.age_in ===
                                      "Date of Birth"
                                        ? patient_list_item.patient_dob_in_date
                                        : `${patient_list_item.patient_dob_in_day}-${patient_list_item.patient_dob_in_month}-${patient_list_item.patient_dob_in_year}`}
                                    </td>
                                    <td>
                                      <Button
                                        danger
                                        onClick={() =>
                                          deleteRowPatient(p_index)
                                        }
                                      >
                                        <DeleteOutlined />
                                        Delete
                                      </Button>
                                    </td>
                                  </tr>
                                )
                            )}
                          </tbody>
                        </ContainerTable>
                      </Col>
                    </>
                  )}
                </Row>
              )}

              {emergencyDtrfDataMap.patient_list.length === 0 && (
                <Row gutter={20}>
                  <Button type="primary" htmlType="submit">
                    SUBMIT
                  </Button>
                </Row>
              )}
            </Form>
            <Form
              form={formSampleInfo}
              layout="vertical"
              onFinish={handleSubmit}
            >
              {emergencyDtrfDataMap.patient_list.map(
                (patient_list_item, p_index) => (
                  <Row gutter={20} style={{ marginBottom: 10 }}>
                    <Card
                      title={`${patient_list_item.patient_name}`}
                      style={{ width: "100%", border: "1px solid #e6e6ea" }}
                    >
                      {patient_list_item.test_list.map(
                        (test_list_item, t_index) => (
                          <Row gutter={20} style={{ marginBottom: 10 }}>
                            {/* <Card style={{ width: '100%' }} > */}
                            <Card
                              title={`${test_list_item.test_name}`}
                              style={{
                                width: "100%",
                                border: "1px solid #e6e6ea",
                              }}
                            >
                              {/* <Meta
														title={`${test_list_item.test_name}`}
														description="This is the description"
														style={{ width: '100%', border: "1px solid #e6e6ea" }}
													/> */}
                              <div style={{ marginBottom: 10 }}>
                                <span style={{ fontWeight: 600 }}>
                                  Test Description :{" "}
                                </span>
                                {test_list_item.test_description}
                              </div>
                              {test_list_item.multiple_sample && (
                                <Row>
                                  <Col xs={24} sm={24} md={12} lg={8} xl={8}>
                                    <Form.Item
                                      label="Sample Type"
                                      name={`sample_id${p_index}${t_index}`}
                                      rules={[
                                        { required: true, message: "Required" },
                                      ]}
                                    >
                                      {/* <Checkbox.Group name={`sample_id${p_index}${t_index}`}> */}
                                      <Space direction="horizontal" wrap>
                                        {test_list_item.sample_type.map(
                                          (item) => (
                                            <>
                                              <Checkbox
                                                checked={_.some(
                                                  test_list_item.sample_container,
                                                  { sample_id: item._id }
                                                )}
                                                value={item._id}
                                                onChange={(e) =>
                                                  handleCheckboxChanged(
                                                    e.target.checked,
                                                    item._id,
                                                    p_index,
                                                    t_index
                                                  )
                                                }
                                              >
                                                {item.sample_type}
                                              </Checkbox>
                                            </>
                                          )
                                        )}
                                      </Space>
                                      {/* </Checkbox.Group> */}
                                    </Form.Item>
                                  </Col>
                                  {/* checked={item._id} */}
                                </Row>
                              )}
                              {test_list_item.multiple_sample === false &&
                                test_list_item.sample_type.length > 0 && (
                                  <Row>
                                    <Col xs={24} sm={24} md={12} lg={8} xl={8}>
                                      <Form.Item
                                        label="Sample Type"
                                        name={`sample_id${p_index}${t_index}`}
                                        rules={[
                                          {
                                            required: true,
                                            message: "Required",
                                          },
                                        ]}
                                      >
                                        <Radio.Group
                                          name={`sample_id${p_index}${t_index}`}
                                          onChange={(e) =>
                                            handleOnChangeRadio(
                                              e.target.value,
                                              t_index,
                                              p_index
                                            )
                                          }
                                        >
                                          <Space direction="horizontal" wrap>
                                            {test_list_item.sample_type.map(
                                              (item) => (
                                                <>
                                                  <Radio
                                                    checked={_.some(
                                                      test_list_item.sample_container,
                                                      { sample_id: item._id }
                                                    )}
                                                    value={item._id}
                                                  >
                                                    {item.sample_type}
                                                  </Radio>
                                                </>
                                              )
                                            )}
                                          </Space>
                                        </Radio.Group>
                                      </Form.Item>
                                    </Col>
                                  </Row>
                                )}
                              <Row
                                gutter={20}
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                {test_list_item.sample_container.map(
                                  (item, c_index) => (
                                    <>
                                      <Col xs={8} sm={8} md={8} lg={8} xl={8}>
                                        <Form.Item
                                          label="Container"
                                          name={`container_id${p_index}${t_index}${c_index}`}
                                          rules={[
                                            {
                                              required:
                                                test_list_item
                                                  .sample_container_list[0]
                                                  ?.container.length > 0
                                                  ? false
                                                  : true,
                                              message: "Required",
                                            },
                                          ]}
                                        >
                                          <Select
                                            showSearch
                                            name={`container_id${p_index}${t_index}${c_index}`}
                                            placeholder="Select Continer"
                                            allowClear
                                            filterOption={true}
                                            onChange={(v) =>
                                              handleContainerChange(
                                                v,
                                                item.sample_id,
                                                t_index,
                                                p_index
                                              )
                                            }
                                            onSearch={_.debounce((value) => {
                                              getContainerList({
                                                sample_id: item.sample_id,
                                                test_group:
                                                  test_list_item.test_group,
                                                dropDownList:
                                                  "/get-dropdown-list-for-container",
                                              });
                                            }, 500)}
                                            notFoundContent={
                                              getContainerListState.apiState ===
                                                "loading" && (
                                                <Spin size="small" />
                                              )
                                            }
                                          >
                                            {getContainerListState.list.map(
                                              (data, t_index) => (
                                                <>
                                                  {data.sample ===
                                                    item.sample_id && (
                                                    <Select.Option
                                                      value={data.container._id}
                                                      key={`${t_index}`}
                                                    >
                                                      {
                                                        data.container
                                                          .display_container_name
                                                      }
                                                    </Select.Option>
                                                  )}
                                                </>
                                              )
                                            )}
                                          </Select>
                                        </Form.Item>
                                      </Col>
                                      <Col xs={8} sm={8} md={8} lg={8} xl={8}>
                                        <Form.Item
                                          rules={[
                                            {
                                              required:
                                                test_list_item
                                                  .sample_container_list[0]
                                                  ?.container.length > 0
                                                  ? false
                                                  : true,
                                              message: "Required",
                                            },
                                          ]}
                                          label="Container ID"
                                          name={`containerId${p_index}${t_index}${c_index}`}
                                        >
                                          <Input
                                            name={`containerId${p_index}${t_index}${c_index}`}
                                            placeholder="Enter Container ID"
                                            onChange={(e) =>
                                              handleContainerID(
                                                e.target.value,
                                                item.sample_id,
                                                t_index,
                                                p_index
                                              )
                                            }
                                          ></Input>
                                        </Form.Item>
                                      </Col>
                                      <Col xs={8} sm={8} md={8} lg={8} xl={8}>
                                        <Button
                                          type="ghost"
                                          onClick={() =>
                                            addRowContainer(
                                              `container_id${p_index}${t_index}${c_index}`,
                                              `containerId${p_index}${t_index}${c_index}`,
                                              item.sample_id,
                                              t_index,
                                              p_index
                                            )
                                          }
                                        >
                                          <PlusCircleOutlined />
                                          Add
                                        </Button>
                                      </Col>
                                      <Col
                                        xs={24}
                                        sm={24}
                                        md={24}
                                        lg={24}
                                        xl={24}
                                      >
                                        <ContainerTable>
                                          <thead>
                                            <tr>
                                              <th>Contianer Name</th>
                                              <th>Contianer ID</th>
                                              <th>Action</th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            {_.some(
                                              test_list_item.sample_container_list,
                                              { sample_id: item.sample_id }
                                            ) &&
                                              _.find(
                                                test_list_item.sample_container_list,
                                                { sample_id: item.sample_id }
                                              ).container.map(
                                                (
                                                  container_item,
                                                  container_index
                                                ) => (
                                                  <tr>
                                                    <td>
                                                      {
                                                        container_item.container_name
                                                      }
                                                    </td>
                                                    <td>
                                                      {
                                                        container_item.containerId
                                                      }
                                                    </td>
                                                    <td>
                                                      <Button
                                                        danger
                                                        onClick={() =>
                                                          deleteRowContainer(
                                                            p_index,
                                                            t_index,
                                                            item.sample_id,
                                                            container_index
                                                          )
                                                        }
                                                      >
                                                        <DeleteOutlined />
                                                        Delete
                                                      </Button>
                                                    </td>
                                                  </tr>
                                                )
                                              )}
                                          </tbody>
                                        </ContainerTable>
                                      </Col>
                                    </>
                                  )
                                )}
                              </Row>
                            </Card>
                          </Row>
                        )
                      )}
                    </Card>
                  </Row>
                )
              )}
              {emergencyDtrfDataMap.patient_list.length > 0 && (
                <Row gutter={20}>
                  <Button type="primary" htmlType="submit">
                    SUBMIT
                  </Button>
                </Row>
              )}
            </Form>
          </LayoutContainer>
        </Card>
      </PageContainer>
    </>
  );
};

const mapStateToProps = (state) => ({
  getListTestMasterState: state.getListTestMaster,
  getContainerListState: state.getContainerList,
  getDoctorDetailState: state.getDoctorDetail,
  getPatientDropdownListState: state.getPatientDropdownList,
  saveEmergencyDtrfState: state.saveEmergencyDtrf,
});

const mapDispatchToProps = (dispatch) => ({
  getListTestMaster: (params) => dispatch(getListTestMaster(params)),
  getListTestMasterReset: () => dispatch(getListTestMasterReset()),
  getContainerList: (params) => dispatch(getContainerList(params)),
  getContainerListReset: () => dispatch(getContainerListReset()),
  getPatientDropdownList: (params) => dispatch(getPatientDropdownList(params)),
  getPatientDropdownListReset: () => dispatch(getPatientDropdownListReset()),
  saveEmergencyDtrf: (params) => dispatch(saveEmergencyDtrf(params)),
  saveEmergencyDtrfReset: () => dispatch(saveEmergencyDtrfReset()),
});

export default connect(mapStateToProps, mapDispatchToProps)(EmergencyDtrfSave);
